import React from "react"
import EditBenefitImg from "../../content/img/editBenefit.png"
import RemoveBenefitImg from "../../content/img/removeBenefit.png"
import { controlEditBenefit, removeChosenedBenefit } from "../../redux/actions"
import { useDispatch, useSelector, shallowEqual } from "react-redux"
import { Row, Col } from "react-bootstrap"
import Swal from "sweetalert2"
import * as Constants from "../../common/constants"

import DeathForm from "./benefitForm/deathForm"
import DisablementForm from "./benefitForm/disablementForm"
import MedicalExpensesForm from "./benefitForm/medicalExpensesForm"
import HospitalAllowanceForm from "./benefitForm/hospitalAllowanceForm"
import BicycleClaimsForm from "./benefitForm/bicycleClaimsForm"
import OtherBenefitsForm from "./benefitForm/otherBenefitsForm"

// import {
//   ComponentAD,
//   ComponentCRI,
//   ComponentME,
//   ComponentPD,
//   ComponentRP,
// } from "./benefitForm/medical"
// import { ComponentHMC, ComponentPAB, ComponentTE } from "./benefitForm/loss"
// import { ComponentML } from "./benefitForm/maid"
// import { ComponentHS } from "./benefitForm/hospital"

import BenefitFormHeader from "./benefitForm/benefitFormHeader"

const BenefitFormsBase = React.memo(() => {
  // console.log("BenefitFormsBase Render!")
  const {
    coverageHeaderList,
    pageNumber,
    chosenedBenefits,
    tempBenefitInfo,
    hideHeaderFooter,
  } = useSelector(state => state.uiData, shallowEqual)

  const { editBenefits } = useSelector(state => state.uiData)

  const RemoveBenefitWarning = Swal.mixin({
    customClass: {
      confirmButton: "swal-button--yes",
      cancelButton: "swal-button--no",
      actions: "swal-footer",
    },
    buttonsStyling: false,
  })

  const benefitFormObject = {
    AD: DeathForm,
    CAD: DeathForm,
    AP: DisablementForm,
    AT: DisablementForm,
    PD: DisablementForm,
    ME: MedicalExpensesForm,
    AM: MedicalExpensesForm,
    AMBI: MedicalExpensesForm,
    AMID: MedicalExpensesForm,
    AMFR: MedicalExpensesForm,
    AMCM: MedicalExpensesForm,
    AMIM: MedicalExpensesForm,
    AMDT: MedicalExpensesForm,
    AMSG: MedicalExpensesForm,
    AMCIM: MedicalExpensesForm,
    HA: HospitalAllowanceForm,
    BAD: BicycleClaimsForm,
    BMD: BicycleClaimsForm,
    BL: BicycleClaimsForm,
    BTH: BicycleClaimsForm,
    OB: OtherBenefitsForm,
  }

  const dispatch = useDispatch()

  const isChosen = (type, Id) => {
    const result = chosenedBenefits.find(
      e => e["Coverage" + type + "Id"] === Id
    )
    return typeof result != "undefined" ? true : false
  }

  let benefitList = []

  coverageHeaderList.forEach((headerItem, headerKey) => {
    headerItem.CoverageDetails.forEach((detailItem, detailKey) => {
      benefitList.push(detailItem)
    })
  })

  return (
    <>
      {coverageHeaderList.map((coverageHeaderItem, coverageHeaderKey) => {
        return (
          <BenefitFormHeader
            key={coverageHeaderKey}
            chosenedBenefits={chosenedBenefits}
            pageNumber={pageNumber}
            coverageHeaderId={coverageHeaderItem.CoverageHeaderId}
            coverageHeaderName={coverageHeaderItem.CoverageHeaderName}
          >
            {coverageHeaderItem.CoverageDetails.map((benefitListItem, key) => {
              const ComponentName =
                benefitFormObject[benefitListItem.CoverageCode]

              if (benefitListItem.Category) {
                return (
                  <div key={key}>
                    <div
                      className={
                        "row form-group bigScreenNarrowing ReviewChoosedDetailDiv " +
                        (pageNumber === Constants.reviewPageNumber &&
                        isChosen("Detail", benefitListItem.CoverageDetailId) &&
                        !editBenefits[benefitListItem.CoverageCode]
                          ? ""
                          : "hide")
                      }
                    >
                      <div className="col-md-10 col-8 summaryBenefit">
                        <b> {benefitListItem.CoverageDetailName} </b>
                      </div>
                      <div className="col-md-2 col-4 row noMarginLeftRightSmallScreen">
                        <div className="col-6 pr-0">
                          <img
                            className="editBtn"
                            src={EditBenefitImg}
                            alt=""
                            onClick={() => {
                              dispatch(
                                controlEditBenefit(benefitListItem.CoverageCode)
                              )
                            }}
                            onKeyDown={() => {
                              dispatch(
                                controlEditBenefit(benefitListItem.CoverageCode)
                              )
                            }}
                            tabIndex="0"
                            role="button"
                          ></img>
                        </div>
                        <div className="col-6 pl-0">
                          <img
                            className="removeBtn"
                            src={RemoveBenefitImg}
                            alt=""
                            onClick={() => {
                              RemoveBenefitWarning.fire({
                                title: "Do you want to remove this claim?",
                                icon: "warning",
                                scrollbarPadding: false,
                                showCancelButton: true,
                                confirmButtonColor: "#ff3333",
                                cancelButtonColor: "#fff",
                                confirmButtonText: "Yes, I do",
                                cancelButtonText: "No, I don’t",
                                focusConfirm: false,
                              }).then(result => {
                                if (result.value) {
                                  dispatch(
                                    removeChosenedBenefit(
                                      benefitListItem.CoverageDetailId
                                    )
                                  )
                                }
                                return false
                              })
                            }}
                            tabIndex="0"
                            role="button"
                          ></img>
                        </div>
                      </div>
                    </div>

                    <Row
                      className={
                        (pageNumber === Constants.benefitFormPageNumber &&
                          benefitListItem.CoverageCode ===
                            tempBenefitInfo.CoverageCode) ||
                        (pageNumber === Constants.reviewPageNumber &&
                          editBenefits[benefitListItem.CoverageCode])
                          ? ""
                          : "hide"
                      }
                    >
                      <div
                        className={
                          "title text-center " +
                          (pageNumber === Constants.benefitFormPageNumber
                            ? ""
                            : "hide") +
                          " " +
                          (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
                        }
                      >
                        {benefitListItem.CoverageDetailName}
                      </div>
                      <Row
                        className={
                          "containerBody summaryContainerBody mb-4 " +
                          (pageNumber === Constants.reviewPageNumber
                            ? "blueBG"
                            : "marginTop3x")
                        }
                      >
                        <Col
                          xs={{ span: 12, offset: 0 }}
                          md={{ span: 12, offset: 0 }}
                          className="formContainer"
                        >
                          <div
                            className={
                              "horizontal-align marginBottom1x " +
                              (pageNumber === Constants.benefitFormPageNumber ||
                              (pageNumber === Constants.reviewPageNumber &&
                                editBenefits[benefitListItem.CoverageCode])
                                ? ""
                                : "hide")
                            }
                          >
                            <Col xs={12} md={12}>
                              <div
                                className={
                                  "titleText " +
                                  (pageNumber === Constants.reviewPageNumber
                                    ? "hide"
                                    : "")
                                }
                              >
                                Claim details
                              </div>
                            </Col>
                          </div>
                          <ComponentName
                            // uiData={uiData}
                            coverageDetail={benefitListItem}
                            // claimData={claimData}
                            // dropdownData={dropdownData}
                          ></ComponentName>
                        </Col>
                      </Row>
                    </Row>
                  </div>
                )
              }
            })}
          </BenefitFormHeader>
        )
      })}
    </>
  )
})

export default BenefitFormsBase
